import { type Meta } from '../types/docs';

export const WORKSPACE_AGENT_ANALYTICS_CATEGORY = 'workspace_agent';

type MetaParam = NonNullable<Meta['params']>[number];

export const WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM = {
  description: 'The product surface this event belongs to',
  name: 'category',
  required: true,
  type: 'enum',
  values: [WORKSPACE_AGENT_ANALYTICS_CATEGORY],
} satisfies MetaParam;

export const withWorkspaceAgentCategory = <T extends Record<string, unknown>>(params: T) => ({
  category: WORKSPACE_AGENT_ANALYTICS_CATEGORY,
  ...params,
});
